[
  "/dashboard",
  "/visits",
  "/referrals",
  "/commissions",
  "/payouts",
  "/settings",
  "/resources",
  "/resources/ambassador-onboarding-checklist",
  "/resources/yachtapp-value-proposition",
  "/resources/approved-social-post-copy",
  "/resources/logo-and-product-screenshots",
  "/resources/referral-disclosure-guidance",
  "/resources/qualified-lead-handoff-notes"
]
